







import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { DateTime } from 'luxon'

@Component
export default class DP extends Vue {

  @Prop()
  private value!: Date

  @Emit('input')
  public input(newValue: Date) {
    // pass
  }

  private changed(newValue: string) {
    const newDate = DateTime.fromFormat(`${newValue} 00:00:00`, 'dd-MMM-yyyy HH:mm:ss').toJSDate()
    this.input(newDate)
  }
}
